<template>
  <div class="d-flex justify-center align-center pt-16 pb-8 mt-16">
    <div class="text-center">
      <img :src="EmptyStateIcon" alt="empty_state" />

      <p class="subtitle-2 blue-grey--text text--darken-1 mt-4">
        {{ $t('home.teams_activity.no_activity_yet') }}
      </p>

      <p class="caption blue-grey--text text--darken-1">
        {{ $t('home.teams_activity.will_see_activity') }}
      </p>
    </div>
  </div>
</template>

<script>
import EmptyStateIcon from '@/assets/images/empty-states/icon-empty-state-swarm.svg'

export default {
  name: 'TeamActivityEmptyState',
  props: {
    hasLink: Boolean,
  },

  data: () => ({
    EmptyStateIcon,
  }),
}
</script>
